import { ParamListBase, RouteProp } from '@react-navigation/native'
import { Stack } from '@zet/design-system'

import { creditCardCrossSellingData } from '../../../api/crossSelling/types'
import ProductCard from '../../../components/productCard'

interface CrossSellingBottomSheetProductCardProps {
  route: RouteProp<ParamListBase>
  creditCardCrossSellingData: creditCardCrossSellingData
  customerId: number
  tier: string
  extraPayoutPercentage: number
}

const CrossSellingBottomSheetProductCard = ({
  route,
  creditCardCrossSellingData,
  customerId,
  tier,
  extraPayoutPercentage,
}: CrossSellingBottomSheetProductCardProps) => {
  const data = creditCardCrossSellingData?.partner
  return (
    <Stack>
      <ProductCard
        partnerId={data?.partnerId}
        customerId={customerId}
        isRecommendationFlow={true}
        isCardOnCard={data?.isCardOnCard}
        dynamicRejectionPayout={data?.dynamicRejectionPayout}
        approvalRate={data?.approvalRate}
        approvalRateTextColor={data?.approvalRateTextColor}
        index={1}
        leadSource="cross_nonapi_rec_bdp"
        route={route}
        isRenderTag={true}
        tier={tier}
        extraPayoutPercentage={extraPayoutPercentage}
      />
    </Stack>
  )
}

export default CrossSellingBottomSheetProductCard
